import { createContext, useContext, useState } from "react";

const RatingContext = createContext();

export function RatingProvider({ children }) {

  const [ratings, setRatings] = useState({});

  const updateRating = (bookId, data) => {
    setRatings((prev) => ({
      ...prev,
      [bookId]: {
        ...prev[bookId],
        ...data,
      },
    }));
  };

  return (
    <RatingContext.Provider value={{ ratings, updateRating }}>
      {children}
    </RatingContext.Provider>
  );
}

export const useRatingContext = () => useContext(RatingContext);